import { Blade } from '@nrdy-marketing-engine/dropdown-menu';
import Search from '@nrdy-marketing-engine/search/src/search';
import useSearchResults from '@nrdy-marketing-engine/search/src/use-search-results';
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import AccountNavItem from './account-nav-item';
import CartIcon from './cart-icon';

const SearchResults = dynamic(() => import('@nrdy-marketing-engine/search/src/search-results'));

export default function NavbarRight({
  menu,
  onSearchFocus,
  searchRef,
  currentBlade,
  toggleBlade,
}: {
  currentBlade: string;
  menu: NavigationMenu;
  onSearchFocus: () => void;
  searchRef: any;
  toggleBlade: (value: any, event: any) => void;
}) {
  const [searchResults, handleSearch] = useSearchResults();
  const [searchFocused, setSearchFocused] = useState(false);
  const ref = useRef<HTMLDivElement>();

  const handleSearchFocus = () => {
    onSearchFocus();
    setSearchFocused(true);
  };

  useOnClickOutside(ref, () => setSearchFocused(false));

  return (
    <div className="flex gap-4 items-center justify-end" ref={ref}>
      {menu.become_a_tutor && (
        <div className="text-sm dark:text-md whitespace-nowrap hover:text-link dark:hover:text-white dark:hover:underline hidden xl:block dark:text-base">
          <a href={menu.become_a_tutor.href}>{menu.become_a_tutor.text}</a>
        </div>
      )}
      {menu.right.search && (
        <div className="relative">
          <Search
            className="xl:-ml-2 xl:-mr-3 dark:xl:-mr-2 focus:mr-0 focus:ml-0 dark:bg-transparent dark:focus:bg-white dark:focus:text-black"
            minimized={!searchFocused}
            onClick={handleSearchFocus}
            onFocus={handleSearchFocus}
            onSearch={handleSearch}
            placeholder={menu.right.search.placeholder}
            ref={searchRef}
          />
          {searchResults && (
            <Blade
              className="left-0 right-0"
              data-testid="blade"
              visible={searchFocused && !!searchResults}
            >
              <SearchResults
                className="bg-white shadow-lg w-full flex-col p-1 text-black"
                results={searchResults}
              />
            </Blade>
          )}
        </div>
      )}
      {menu.right.cart && (
        <CartIcon className="xl:border-l-[1px] xl:border-gray-200 xl:pl-4 dark:hidden" />
      )}
      <AccountNavItem
        className="hidden xl:block"
        currentBlade={currentBlade}
        menu={menu}
        toggleBlade={toggleBlade}
      />
    </div>
  );
}
